var exports = {
  "n": "IssueTypeToken__Ml4JTm",
  "_": "hiddenPlaceholder__Aaw2ly",
};

module.exports = exports;
